// Whether a file's bytes may be served to somebody with no credential at all.
//
// WHAT THIS DECIDES, AND WHAT IT DOES NOT
//
// It gates ONE route: the anonymous `/file/by-host/…` form, which a visitor to
// a published page reaches on the site's own verified hostname. The
// authenticated `/file/<siteId>/…` route the Files screen uses is unaffected —
// a signed-in member of the organization may read any of their own files, and
// this value says nothing about that.
//
// So `private` is not "hidden from the owner". It is "not part of the website".
//
// TWO STATES AND NOT A BOOLEAN
//
// The same reason every other status in this service is a string: there is a
// third state that can be wanted later — bytes served under a signed URL with
// an expiry — and a boolean has nowhere to put it. It also reads in a log line,
// which `isPublic: false` does not.
export const PRIVATE = "private";
export const PUBLIC = "public";

export const VISIBILITIES = [PRIVATE, PUBLIC];

// UNKNOWN IS PRIVATE, AND SO IS ABSENT.
//
// The same asymmetry @common/schema/site-domain/status argues for, for the same
// reason and one step further. A row written before this field existed carries
// no value, and every file uploaded to this service before it did was uploaded
// on the understanding that a credential was needed to read it. Defaulting
// those to public on the strength of their kind would publish somebody's files
// as a side effect of a deploy — the one outcome this whole field exists to put
// a person in charge of.
//
// So the test is equality with the one string, never absence of the other.
export const isPublic = (row) => Boolean(row) && row.visibility === PUBLIC;

export const isVisibility = (value) => VISIBILITIES.includes(value);
